window.addEventListener('load', function () {
    var kickers = Array.prototype.slice.call(document.querySelectorAll('.eht-headline--animation'));
    kickers.forEach(function (kicker) {
        var label = kicker.textContent.trim();
        kicker.setAttribute('aria-label', label);
        kicker.classList.add('is-split');
        kicker.innerHTML = '';

        Array.from(label).forEach(function (char, index) {
            var span = document.createElement('span');
            span.setAttribute('aria-hidden', 'true');
            span.style.setProperty('--kicker-index', index);
            span.innerHTML = char === ' ' ? '&nbsp;' : char;
            kicker.appendChild(span);
        });
    });


    if ('IntersectionObserver' in window) {
        var kickerObserver = new IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
                if (entry.isIntersecting) {
                    entry.target.classList.add('is-animated');
                    kickerObserver.unobserve(entry.target);
                }
            });
        }, { threshold: 0.55 });

        kickers.forEach(function (kicker) {
            kickerObserver.observe(kicker);
        });
    } else {
        kickers.forEach(function (kicker) {
            kicker.classList.add('is-animated');
        });
    }
});